import { render, staticRenderFns } from "./supplierCase.vue?vue&type=template&id=0b01dbdc&scoped=true"
import script from "./supplierCase.vue?vue&type=script&lang=js"
export * from "./supplierCase.vue?vue&type=script&lang=js"
import style0 from "./supplierCase.vue?vue&type=style&index=0&id=0b01dbdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b01dbdc",
  null
  
)

export default component.exports